import { canv } from "@/canv/global.js";
import type { ExtendsOfElementBase } from "@/canvasController/types";
import type { DocumentViewerWidget, ViewMode } from "@/elements/documentViewer/DocumentViewer";
import type { widgetOption } from "@/widgetMenu/widgetMenu";
import { wmBase } from "@/widgetMenu/wmBase";

const COMPACT_SVG = `                
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.12415 11.0615C8.53832 11.0556 8.87896 11.3866 8.88489 11.8008L8.95911 16.9854C8.9649 17.3994 8.63394 17.7402 8.21985 17.7461C7.806 17.7517 7.46517 17.4207 7.45911 17.0068L7.41125 13.6318L2.28723 18.9072C1.99871 19.2042 1.5238 19.2111 1.22668 18.9229C0.929858 18.6343 0.92275 18.1594 1.21106 17.8623L6.33508 12.5869L2.96301 12.6348C2.54903 12.6407 2.20845 12.3104 2.20227 11.8965C2.19634 11.4823 2.52739 11.1417 2.94153 11.1357L8.12415 11.0615ZM17.7335 1.07324C18.0332 0.787404 18.5081 0.799027 18.7941 1.09863C19.0795 1.39827 19.068 1.87237 18.7687 2.1582L13.4493 7.23633L16.8214 7.31543C17.2353 7.32538 17.5626 7.66905 17.5529 8.08301C17.5431 8.49689 17.2001 8.82489 16.7863 8.81543L11.6036 8.69336C11.1896 8.68361 10.8615 8.33987 10.8712 7.92578L10.9933 2.74219C11.0031 2.32819 11.3468 2.00004 11.7609 2.00977C12.1746 2.01978 12.5029 2.36352 12.4933 2.77734L12.4132 6.15137L17.7335 1.07324Z" fill="#2C2D32"/>
    </svg>
`;

const EXPAND_SVG = `
    <svg fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
        <path d="m7.71094 11.3916c.29291-.2928.76769-.2929 1.06054 0 .29251.2929.29268.7678 0 1.0605l-5.20996 5.209h3.38184c.414.0002.74994.336.75.75-.00025.4139-.33612.7498-.75.75h-5.19238c-.41406 0-.74975-.336-.75-.75v-5.1914c.00001-.4142.33579-.75.75-.75.41418 0 .74998.3358.75.75v3.3809zm10.53806-10.551756c.4141.000107.75.335856.75.749996v5.19141c0 .41415-.3359.74989-.75.75-.4142-.00004-.75-.33581-.75-.75v-3.38184l-5.2099 5.20997c-.2929.29284-.7677.29289-1.0606 0-.2928-.29291-.2928-.76769 0-1.06055l5.21-5.20899h-3.3819c-.4141-.00012-.75-.33586-.75-.75 0-.41413.3359-.749873.75-.749996z" fill="#2c2d32"/>
    </svg>
`;

export class WmDocumentMode extends wmBase {
    constructor(options: widgetOption<ViewMode>[]) {
        super();
        this.mode = options[0].value;
    }

    build() {
        return `
            <div class="wm_documentMode">
              ${this.mode === "compact" ? EXPAND_SVG : COMPACT_SVG}
            </div>
        `;
    }

    init() {
        const item = document.querySelector(".wm_documentMode");
        item?.removeEventListener("click", this.itemClick, false);
        item?.addEventListener("click", this.itemClick, false);
    }

    itemClick = (): void => {
        const selectedEntities = canv.canvasController.selected;
        function isDocumentViewer(obj: ExtendsOfElementBase): obj is DocumentViewerWidget {
            return obj?.constructorName === "documentViewer";
        }

        if (selectedEntities.length === 1 && selectedEntities[0].isItemWrapper()) {
            const child = selectedEntities[0].onlyChild() as ExtendsOfElementBase | null;
            if (child && isDocumentViewer(child)) {
                child.switchViewMode();
            }
        }
    };
    mode: ViewMode = "compact";
}
